var NoteView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

View = require('./base/view');

template = require('./templates/note');

module.exports = NoteView = (function(_super) {
  __extends(NoteView, _super);

  function NoteView() {
    _ref = NoteView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  NoteView.prototype.template = template;

  NoteView.prototype.tagName = 'li';

  NoteView.prototype.className = 'item';

  NoteView.prototype.events = {
    'click .btn-delete': 'deleteNote',
    'click .btn-edit': 'editNote',
    'click .btn-save': 'saveNote'
  };

  NoteView.prototype.listen = {
    'change model': 'render'
  };

  NoteView.prototype.deleteNote = function() {
    this.model.destroy();
    return false;
  };

  NoteView.prototype.editNote = function() {
    this.publishEvent('note:startEdit', this.$el);
    this.$el.addClass('edit');
    return false;
  };

  NoteView.prototype.saveNote = function() {
    this.model.save({
      text: this.$('.item-text-edit').val()
    });
    this.$el.removeClass('edit');
    this.publishEvent('note:finishEdit', this.$el);
    return false;
  };

  return NoteView;

})(View);
